import gql from "graphql-tag"

export const DELETE_AVARDA_CONFIG = gql`
  mutation deleteAvardaConfig($id: ID!) {
    deleteAvardaConfig(id: $id) {
      status
    }
  }
`
